import React from 'react';
import {
  useField,
} from 'formik';

import FieldsSingleSelect from './FieldsSingleSelect.jsx';
import FieldsMultiSelect from './FieldsMultiSelect.jsx';
import FieldsOrdering from './FieldsOrdering.jsx';
import FieldsMatching from './FieldsMatching.jsx';
import FieldsImageDragDrop from './FieldsImageDragDrop.jsx';
import FieldsSentenceCompletion from './FieldsSentenceCompletion.jsx';
import FieldsIdioms from './FieldsIdioms.jsx';

const FieldsQtnOpts = ({
  idx,
  qtnIndex: i,
  restrictEdit,
  fileUploadUrl,
}) => {
  const [, { value }] = useField(`questionSets[${idx}].questions.${i}`);
  const { format = 'single-select' } = value;
  let Options = FieldsSingleSelect; // default format
  console.log({ value });
  if (format === 'multi-select') Options = FieldsMultiSelect;
  if (format === 'ordering') Options = FieldsOrdering;
  if (format === 'matching') Options = FieldsMatching;
  if (format === 'image-dragdrop') Options = FieldsImageDragDrop;
  if (format === 'sentence-completion') Options = FieldsSentenceCompletion;
  if (format === 'idiom-fill') Options = FieldsIdioms;

  return (
    <Options
      idx={idx}
      qtnIndex={i}
      restrictEdit={restrictEdit}
      fileUploadUrl={fileUploadUrl}
    />
  );
};

export default FieldsQtnOpts;
